export default __webpack_public_path__ + "static/media/patient-care.7d896061.png";